import React from 'react';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { translate } from 'react-i18next';
import './calendar.scss';

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

const Calendar = ({ t, events, loading, selectedYear }) =>
  <div className="event-calendar">
    <div className="calendar">
      {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month) =>
        <div className={"calendar-container " + moment(month, 'MM').format('MMM').toLowerCase()} key={month}>
          <h3 className="month-text">{t(moment(month, 'MM').format('MMMM'))}</h3>
          <BigCalendar
            events={events}
            titleAccessor="description"
            selectable={true}
            onSelectSlot={(e) => console.log(e)}
            views={['month']}
            toolbar={false}
            date={new Date(`${selectedYear}-${month}-01`)}
            eventPropGetter={event => ({style: {backgroundColor: event.color}})}
            onNavigate={(e) => console.log(e)} />
        </div>
      )}
    </div>
  </div>

export default translate('events')(Calendar);



// WEBPACK FOOTER //
// ./src/components/events/Calendar.js